import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/promote/sponsors")({
  // Component in lazy file for code splitting
});
